module.exports = __webpack_public_path__ + "media/src/img/close-icon-2ee645961cc90509c8fe4c85b96791cd.svg";